// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './components/HomePage';
import './App.css';
import ShareAndEarn from './components/ShareAndEarn';

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<ShareAndEarn/>} />
          <Route path="/shareandearn" element={<ShareAndEarn />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
